<template>
    <az-formbar>
        <div :class="inserindo ? 'hide' : 'show'">
            <div class="itens" v-if="!inserindo">
                <div class="item">
                    <label>Dados</label><!-- eslint-disable-next-line -->
<!--                    <span>{{usuario.situacao | az-title-case }}</span>-->
                </div>
            </div>
<!--            <div class="actions" v-if="!inserindo">-->
<!--                <usuario-acoes-ativar-inativar v-az-auth="'Usuario.AtivarInativar'"/>-->
<!--            </div>-->
        </div>
    </az-formbar>
</template>

<script>
    import {mapState} from 'vuex'
    import UsuarioAcoesAtivarInativar from './UsuarioAcoesAtivarInativar'

    export default {
        name: 'UsuarioAcoes',
        components: {UsuarioAcoesAtivarInativar},
        props: {
            inserindo: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState(['usuario'])
        }
    }
</script>

<style scoped lang="stylus">

    .item
        label
            font-weight: bold

</style>
